import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// utils
import { localStorageGetItem } from 'src/utils/storage-available';
//
import { defaultLang } from './config-lang';
//
import translationEn from './locales/en/translation.json';
import translationCn from './locales/zh/translation.json';
import translationIt from './locales/it/translation.json';
import translationEs from './locales/es/translation.json';
import translationSv from './locales/sv/translation.json';

// ----------------------------------------------------------------------

const lng = localStorageGetItem('i18nextLng', defaultLang.value);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: translationEn },
      cn: { translations: translationCn },
      it: { translations: translationIt },
      es: { translations: translationEs },
      sv: { translations: translationSv },
    },
    lng,
    fallbackLng: lng,
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
